<template v-cloak>
    <nav :aria-label="label" class="pagination text-center space-y space-y--top-0">
        <ul class="search-pagination__list pagination__list">
            <li>
                <button @click="setPrev"
                        :disabled="currentPage === 1"
                        class="prev page-numbers"
                        :aria-disabled="currentPage === 1"
                >
                    <i class="icon-keyboard_arrow_left" aria-hidden="true" role="img" />
                    <span class="screen-reader-text" v-html="prev_text" />
                </button>
            </li>
            <li v-for="(link, index) in pagination.links" :key="index">
                <button
                    v-if="!link.disabled || !!link.active"
                    @click.prevent="setPage(link.page)"
                    class="page-numbers"
                    :aria-current="currentPage === link.page ? 'page' : false"
                    :class="{ 'current': link.active }"
                    :disabled="currentPage === link.page"
                >
                    <span class="screen-reader-text" v-html="before_page_number" /> {{ link.text }}
                </button>
                <span v-else class="page-numbers dots">{{ link.text }}</span>
            </li>
            <li>
                <button
                    @click="setNext"
                    :disabled="currentPage === totalPages"
                    :aria-disabled="currentPage === totalPages"
                    class="next page-numbers"
                >
                    <i class="icon-keyboard_arrow_right" aria-hidden="true" role="img" />
                    <span class="screen-reader-text" v-html="next_text" />
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Pagination'
        },
        before_page_number: {
            type: String,
            default: 'Page'
        },
        prev_text: {
            type: String,
            default: 'Previous page'
        },
        next_text: {
            type: String,
            default: 'Next page'
        }
    },
    computed: {
        /**
         * Return amount of pages.
         * @return {number}
         */
        totalPages() {
            return parseInt( this.$store.getters[ 'totalPages' ] )
        },

        /**
         * Return current Page ID.
         * @return {number}
         */
        currentPage() {
            return parseInt( this.$store.getters[ 'page' ] )
        },

        /**
         * Returns the pagination.
         *
         * @return {{next: (number|boolean), current: number, prev: (number|boolean), links: *[]}}
         */
        pagination() {
            const current = this.currentPage;
            const total = this.totalPages;
            const midSize = 2;
            const links = [];

            // Add the first page link
            links.push( {
                text: '1',
                page: 1,
                active: ( current === 1 ),
                disabled: ( current === 1 )
            } );

            // Determine the range of pages to show
            let start = Math.max( 2, current - midSize );
            let end = Math.min( current + midSize, total - 1 );

            // Add the dots if necessary
            if ( start > 2 ) {
                links.push( {
                    text: '...',
                    page: false,
                    active: false,
                    disabled: true
                } );
            }

            // Add the middle page links
            for ( let i = start; i <= end; i++ ) {
                links.push( {
                    text: i.toString(),
                    page: i,
                    active: ( i === current ),
                    disabled: false
                } );
            }

            // Add the dots if necessary
            if ( end < total - 1 ) {
                links.push( {
                    text: '...',
                    page: false,
                    active: false,
                    disabled: true
                } );
            }

            // Add the last page link
            if ( total > 1 ) {
                links.push( {
                    text: total.toString(),
                    page: total,
                    active: ( current === total ),
                    disabled: ( current === total )
                } );
            }

            // Determine the previous and next pages
            const prev = ( current > 1 ) ? current - 1 : false;
            const next = ( current < total ) ? current + 1 : false;

            return {
                current,
                prev,
                next,
                links
            };
        }
    },
    methods: {
        setNext() {
            this.$store.dispatch( 'setPage', parseInt( this.$store.getters[ 'page' ] ) + 1 )
        },
        setPrev() {
            this.$store.dispatch( 'setPage', parseInt( this.$store.getters[ 'page' ] ) - 1 )
        },
        setPage( pageNo ) {
            this.$store.dispatch( 'setPage', parseInt( pageNo ) )
        }
    }
}
</script>
